import { aboutContent } from '@/mocks/darkwebData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
              {aboutContent.title}
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutContent.description.split('\n\n').map((paragraph, idx) => (
                <p key={idx}>{paragraph}</p>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[360px] shrink-0">
            <div className="grid grid-cols-2 gap-4">
              {aboutContent.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 border border-background-200/70 rounded-lg p-5 text-center"
                >
                  <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}